// Step 18 — AI Settings.
//
// The AI application has NO dedicated settings today. Rather than
// inventing an AI configuration system, this page acknowledges the
// gap and links out to the existing broker-portal settings endpoints
// where the underlying settings actually live (Konto, arbetsyta,
// prenumeration, notiser). Cross-subdomain via the shared
// hostRouting helper from Step 17.

import { brokerPortalUrl } from "../../services/hostRouting";

import {
  AIEmpty,
  AIPageHeader,
  AISection,
} from "../shell/AIPrimitives";
import { useAIWorkspace } from "../shell/AIWorkspaceContext";

export default function AISettings() {
  const { user } = useAIWorkspace();
  const brokerSettingsUrl = brokerPortalUrl("/settings");

  return (
    <>
      <AIPageHeader
        title="Inställningar"
        subtitle={user?.email || undefined}
      />
      <AISection title="Konto">
        <AIEmpty
          title="Ingen AI-specifik inställning ännu"
          hint="Kontoinställningar, prenumeration och notiser hanteras i broker-portalen. Länken nedan öppnar samma inloggning."
        >
          {brokerSettingsUrl && (
            <div style={{ marginTop: 12 }}>
              <a
                href={brokerSettingsUrl}
                className="qai-outreach-review-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Öppna kontoinställningar
              </a>
            </div>
          )}
        </AIEmpty>
      </AISection>
    </>
  );
}
